import { CustomTrace } from '../../../chart-kit/shared/utils/chartModel'

/**
 * semi-unique trace identifier
 * TODO: are those editable traces? -> not specifically for custom charts
 */
export const getUniqueIdentifierFromCustomTrace = (customTrace: CustomTrace): string | null => {
  if (!customTrace) {
    return null
  }

  if (customTrace.alternateKey) {
    return customTrace.alternateKey
  }

  return customTrace.key
}
